import React, { useEffect, useState } from "react";
import { getComments, createComment } from "../../api/ideas";
import IdeaCommentItem from "./IdeaCommentItem";
import { useSanctions } from "../../context/SanctionsContext";
import MutedNotice from "../MutedNotice";

/**
 * Список комментов идеи + форма ввода (показывается только если canAct).
 */
export default function IdeaCommentList({ ideaId, canAct }) {
  const [items, setItems] = useState(null);
  const [text, setText] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const { isMuted } = useSanctions();

  useEffect(() => {
    const ctl = new AbortController();
    getComments(ideaId, { signal: ctl.signal })
      .then((d) => setItems(d.items || []))
      .catch((e) => {
        if (e.name !== "AbortError") setErr(e.message);
      });
    return () => ctl.abort();
  }, [ideaId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim() || busy) return;
    setBusy(true);
    setErr(null);
    try {
      const res = await createComment(ideaId, text.trim());
      // оптимистичный insert наверх, перерисуется при следующей пагинации
      setItems((arr) => [
        {
          id: res.id,
          idea_id: ideaId,
          text: text.trim(),
          likes: 0,
          is_liked: false,
          hidden: false,
          created_at: res.created_at || new Date().toISOString(),
          author_name: "Вы",
        },
        ...(arr || []),
      ]);
      setText("");
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      {canAct && isMuted ? (
        <div style={{ marginBottom: 16 }}>
          <MutedNotice action="comment" />
        </div>
      ) : canAct ? (
        <form className="idz-comment-form" onSubmit={submit}>
          <textarea
            className="idz-textarea"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Напиши комментарий…"
            maxLength={1000}
            rows={3}
          />
          {err && <div className="idz-err">{err}</div>}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span className="idz-hint">{text.length}/1000</span>
            <button
              type="submit"
              className="idz-btn-primary"
              disabled={!text.trim() || busy}
            >
              {busy ? "Отправка…" : "Отправить"}
            </button>
          </div>
        </form>
      ) : (
        <div className="idz-hint" style={{ padding: "12px 0" }}>
          Войди и подтверди email, чтобы оставлять комментарии.
        </div>
      )}

      <div style={{ height: 16 }} />

      {items == null ? (
        <div className="idz-loading">Загрузка комментариев…</div>
      ) : items.length === 0 ? (
        <div className="idz-empty">Пока нет комментариев. Стань первым!</div>
      ) : (
        <div className="idz-comment-list">
          {items.map((c) => (
            <IdeaCommentItem
              key={c.id}
              comment={c}
              canAct={canAct}
              onError={setErr}
            />
          ))}
        </div>
      )}
    </div>
  );
}
